module.exports = __webpack_public_path__ + "static/media/BadgeTemplates-81.7c004469.svg";